import React, { useContext, useEffect, useState } from "react";
import {
    Badge,
    Button,
    Form,
    Input,
    Modal,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { context } from "./../../context/context";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

const AdminsTable = () => {
    //persian
    const PN = require("persian-number");
    const [form] = Form.useForm();

    //state
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [lastName, setLastName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [addPassword, setAddPassword] = useState("");
    const [addUserName, setAddUserName] = useState("");
    const [addLastName, setAddLastName] = useState("");
    const [addFirstName, setAddFirstName] = useState("");

    //context
    const {
        setForceUpdate,
        forceUpdate,
        isAdminModalOpen,
        setIsAdminModalOpen,
    } = useContext(context);
    //functions
    const handleEdit = (record) => {
        setUserId(record._id);
        setPassword(record.password);
        setFirstName(record.firstName);
        setLastName(record.lastName);
    };
    const handleOkEditModal = () => {
        http.post(`${config.parkopoloApi}/api/User/edit`, {
            userId,
            password,
            firstName,
            lastName,
        })
            .then((res) => {
                setForceUpdate(40);
                toast.success("ادمین با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            });
        setEditModalOpen(false);
        setFirstName("");
        setLastName("");
        setPassword("");
    };
    const handleOkAdminModal = () => {
        http.post(`${config.parkopoloApi}/api/User/add`, {
            username: addUserName,
            password: addPassword,
            firstName: addFirstName,
            lastName: addLastName,
            role: "admin",
        })
            .then((res) => {
                setForceUpdate(40);
                toast.success("ادمین با موفقیت اضافه شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            });
        setAddFirstName("");
        setAddLastName("");
        setAddPassword("");
        setAddUserName("");
        setIsAdminModalOpen(false);
    };
    const handleCancelModal = () => {
        setEditModalOpen(false);
        setIsAdminModalOpen(false);
    };
    //useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/User/`)
            .then((res) => {
                setTableData(res.data.result);
                setForceUpdate(20);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);
    console.log(tableData);
    const columns = [
        {
            title: "نام و نام خانوادگی",

            width: "5%",
            render: (_, { firstName, lastName }) => (
                <>
                    <Typography.Paragraph>
                        <Tag color="green">
                            <h5>
                                {firstName} {lastName}
                            </h5>
                        </Tag>
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "نام کاربری",

            width: "10%",
            render: (_, { username }) => (
                <>
                    <Typography.Paragraph>
                        <Tag color="cyan">
                            <p style={{ color: "black" }}>
                                {PN.convertEnToPe(username)}
                            </p>
                        </Tag>
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "0.5%",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            disabled
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش ادمین">
                            <Button
                                disabled
                                onClick={() => {
                                    handleEdit(record);
                                    setEditModalOpen(true);
                                }}
                                type="primary"
                                icon={<EditOutlined />}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            />
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];
    return (
        <>
            <Table
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                }}
                style={{ marginTop: "15px" }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
            />
            {/* <Modal
                title="ویرایش"
                open={editModalOpen}
                onOk={handleOkEditModal}
                onCancel={handleCancelModal}
                okText="ویرایش"
            >
                <div style={{ marginTop: "30px" }}>
                    <Badge.Ribbon
                        placement="start"
                        style={{ marginTop: "-18px", marginRight: "10px" }}
                        text="نام"
                    >
                        <Input
                            style={{ margin: "10px", width: "80%" }}
                            placeholder="نام را وارد کنید"
                            value={firstName}
                            onChange={(e) => {
                                setFirstName(e.target.value);
                            }}
                        />
                    </Badge.Ribbon>
                </div>
                <div style={{ marginTop: "30px" }}>
                    <Badge.Ribbon
                        placement="start"
                        style={{ marginTop: "-18px", marginRight: "10px" }}
                        text="نام خانوادگی"
                    >
                        <Input
                            style={{ margin: "10px", width: "80%" }}
                            placeholder="نام خانوادگی را وارد کنید"
                            value={lastName}
                            onChange={(e) => {
                                setLastName(e.target.value);
                            }}
                        />
                    </Badge.Ribbon>
                </div>
                <div style={{ marginTop: "30px" }}>
                    <Badge.Ribbon
                        placement="start"
                        style={{ marginTop: "-18px", marginRight: "10px" }}
                        text="پسوورد"
                    >
                        <Input
                            style={{ margin: "10px", width: "80%" }}
                            placeholder="پسوورد را وارد کنید"
                            // value={}
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />
                    </Badge.Ribbon>
                </div>
            </Modal> */}
            <Modal
                title="افزودن ادمین"
                open={isAdminModalOpen}
                onCancel={handleCancelModal}
                okButtonProps={{ hidden: true }}
                cancelButtonProps={{hidden: true}}
            >
                <div

                >
                    <Form
                        onFinish={handleOkAdminModal}
                        layout="vertical"
                        form={form}
                        name="control-hooks"
                        style={{
                            direction: "rtl",
                            display: "flex",
                            flexDirection:"column",
                            gap: "15px",
                            // margin: "15px",
                        }}

                    >
                        <Form.Item
                        style={{marginTop:"10px"}}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                            name="نام"
                        >
                            <div>
                                <Badge.Ribbon
                                    placement="start"
                                    style={{
                                        marginTop: "-18px",
                                        marginRight: "10px",
                                    }}
                                    text="نام"
                                >
                                    <Input
                                        style={{
                                            margin: "10px",
                                            width: "100%",
                                        }}
                                        placeholder="نام را وارد کنید"
                                        value={addFirstName}
                                        onChange={(e) => {
                                            setAddFirstName(e.target.value);
                                        }}
                                    />
                                </Badge.Ribbon>
                            </div>
                        </Form.Item>
                        <Form.Item
                        name="نام خانوادگی"

                        >
                            <Badge.Ribbon
                                placement="start"
                                style={{
                                    marginTop: "-18px",
                                    marginRight: "10px",
                                }}
                                text="نام خانوادگی"
                            >
                                <Input
                                    style={{ margin: "10px", width: "100%" }}
                                    placeholder="نام خانوادگی را وارد کنید"
                                    value={addLastName}
                                    onChange={(e) => {
                                        setAddLastName(e.target.value);
                                    }}
                                />
                            </Badge.Ribbon>
                        </Form.Item>
                        <Form.Item
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="نام کاربری"
                        >
                            <div>
                                <Badge.Ribbon
                                    placement="start"
                                    style={{
                                        marginTop: "-18px",
                                        marginRight: "10px",
                                    }}
                                    text="نام کاربری"
                                >
                                    <Input
                                        style={{
                                            margin: "10px",
                                            width: "100%",
                                        }}
                                        placeholder="مثلا : 09125555550"
                                        value={addUserName}
                                        onChange={(e) => {
                                            setAddUserName(e.target.value);
                                        }}
                                    />
                                </Badge.Ribbon>
                            </div>
                        </Form.Item>
                        <Form.Item
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="رمز عبور"
                        >
                            <div>
                                <Badge.Ribbon
                                    placement="start"
                                    style={{
                                        marginTop: "-18px",
                                        marginRight: "10px",
                                    }}
                                    text="رمز عبور"
                                >
                                    <Input
                                        style={{
                                            margin: "10px",
                                            width: "100%",
                                        }}
                                        placeholder="رمز عبور"
                                        value={addPassword}
                                        onChange={(e) => {
                                            setAddPassword(e.target.value);
                                        }}
                                    />
                                </Badge.Ribbon>
                            </div>
                        </Form.Item>
                        <Form.Item>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                alignItems: "center",
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                ثبت
                            </Button>
                            <Button
                                type="primary"
                                danger
                                onClick={handleCancelModal}
                            >
                                لغو
                            </Button>
                        </div>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default AdminsTable;
